export default {
  common: {
    yes: '是',
    no: '否',
    currency: { php: 'PHP', vnd: 'VND', cny: 'CNY', all: '全部币种' },
    status: {
      sufficient: '充足 {pct}%',
      warning: '预警 {pct}%',
      exhausted: '已耗尽',
      unallocated: '未分配',
    },
    change: { add: '+ 增加', sub: '- 减少', consume: '调账消耗' },
    remaining: '剩余可用',
    totalAmount: '总额度',
    usedAmount: '已用',
    noPermission: '- 无权查看 -',
    self: '（自己）',
    exportExcel: '导出 Excel',
  },
  sys: {
    column: {
      title: '用户调账额度',
      subtitle: '可用 / 总额度',
      subtitleNew: '平台运营后台 · 给玩家调账',
      tagRefactor: '改造',
    },
    btn: { manage: '额度管理', manageNew: '新' },
    section: {
      userTitle: '用户调账额度',
      userSubtitle: '平台运营后台 · 给玩家调账',
      agentTitle: '代理调账额度',
      agentSubtitle: '市场推广 · 给代理分配',
    },
    manage: {
      title: '后台账号额度管理',
      totalUsed: '已用合计：',
      remainingLabel: '剩余可用',
      monthlyConsumed: '本月已消耗',
      monthlyUser: '用户',
      monthlyAgent: '代理',
      viewAllPrefix: '所有额度变更明细统一查看',
      viewAllLink: '调账限额变更记录',
      recentChanges: '最近变更',
      recentChangesSub: '最近 5 条',
      viewAll: '查看完整明细 →',
      memberLabel: '会员',
      typeAdd: '+ 增加',
      typeSub: '- 减少',
      typeConsume: '调账消耗',
      col: {
        time: '时间',
        type: '类型',
        currency: '币种',
        change: '变动',
        afterRemain: '变更后',
        operatorRemark: '操作人 / 备注',
      },
    },
    adjust: {
      title: '调整调账额度',
      opType: '操作类型',
      add: '+ 增加',
      sub: '- 减少',
      amount: '金额（{currency}）',
      reason: '变更原因',
      reasonPlaceholder: '请填写此次额度变更的原因（审计追溯用）',
      reasonMaxLen: '最多 100 字符',
      amountRequired: '请输入金额',
      amountMin: '金额必须大于 0',
      reasonRequired: '请填写变更原因',
      preview: {
        after: '→ 调整后：剩余 {remain} / 总额 {total}',
        error: '⚠ 不可减少至此值，超过剩余可用额度（{remain}）',
      },
      myAvailable: '我的可用额度（{currency}）',
      myQuotaEmpty: '⚠ 您当前没有可用的代理调帳额度，无法给代理增加。请联系超管补充。',
      exceedMyQuota: '⚠ 超过您的可用额度（{myAvailable}），无法增加这么多。',
      singleLimit: {
        exceeded: '单笔{dir}上限为 {cur} {max}，本次 {cur} {amount} 已超限',
        add: '加额度',
        reduce: '减额度',
      },
      success: '操作成功',
      fail: '操作失败',
    },
  },
  financial: {
    title: '调账额度变更记录',
    desc: '本页面记录所有后台账号的调账额度变更，包含两类：① 额度调账（管理员手动调整账号额度）；② 会员调账（操作员执行会员手工调账时实时扣减自身额度）。变更前/后均显示「可用 / 总额度」。',
    tab: {
      opUser: '后台账号额度',
      agentAlloc: '代理额度分配',
      agentBetween: '代理间额度分配',
      memberAlloc: '玩家额度分配',
      opUserGrant: '新增代理额度记录',
    },
    usage: {
      allocate: '额度分配',
      recycle: '额度回收',
    },
    targetTag: {
      opUser: '后台账号',
      agent: '代理',
      member: '玩家',
    },
    level: {
      platform: '平台',
      l1: '一级代理',
      l2: '二级代理',
      agent: '代理',
      superAdmin: '超级管理员',
    },
    filter: {
      timeRange: '变更时间',
      startDate: '开始日期',
      endDate: '结束日期',
      operator: '操作人',
      operatorPlaceholder: '操作人账号',
      targetAccount: '目标账号',
      targetPlaceholder: '目标后台账号',
      agentAccount: '目标代理',
      agentPlaceholder: '代理账号搜索',
      memberAccount: '目标玩家',
      memberPlaceholder: '玩家账号搜索',
      bizType: '变更类型',
      bizTypeAll: '全部类型',
      currency: '币种',
      currencyAll: '全部币种',
    },
    bizType: {
      adjustConsume: '会员调账',
      quotaAdjust: '额度调账',
      opUserRefundFromMember: '会员扣款退回',
    },
    col: {
      id: 'ID',
      time: '变更时间',
      usage: '用途',
      operator: '操作人',
      operatorLevel: '操作人层级',
      adjustReason: '调账原因',
      refundFlag: '是否回收额度',
      countPayDeposit: '是否计入存提',
      targetAccount: '目标账号',
      targetMember: '目标会员',
      currency: '币种',
      bizType: '变更类型',
      changeAvailable: '可用额度变动',
      changeTotal: '总额度变动',
      beforeAfterAvailable: '变更前 → 变更后（可用）',
      beforeAfterTotal: '变更前 → 变更后（总额度）',
      grantAmount: '新增金额',
      grantAmountSub: '可用与总额度同增',
      afterQuota: '变更后',
      afterQuotaSub: '可用 / 总额度',
      bizNo: '业务单号',
      remark: '备注',
    },
  },
  my: {
    menuItem: '我的调账额度',
    modal: { title: '我的调账额度' },
    desc: '仅展示当前登录账号的额度与消耗明细。如需补充额度，请联系拥有「后台账号.额度.管理」权限的账号。',
    hero: { onlySelf: '这是当前登录账号 · 仅自己可见', monthConsumed: '本月已消耗：', account: '账号', role: '角色' },
    currentQuota: { title: '当前可用额度', subtitle: '实时数据 · 每次调账成功后自动刷新' },
    agentAlloc: {
      title: '代理调账额度',
      subtitle: '给代理（一级/二级）分配额度 · 实时数据 · 分配/回收成功后自动刷新',
      monthUsed: '本月已用',
    },
    card: { remainLabel: '剩余可用额度', total: '总额度: {val}', monthUsed: '本月已用: {val}' },
    filter: {
      time7d: '近 7 天', time30d: '近 30 天',
      timeMonth: '本月', timeLastMonth: '上月',
      allCurrencies: '全部币种', allTypes: '全部类型',
      consumeType: '调账消耗', addType: '管理员增加', subType: '管理员减少',
    },
    table: {
      time: '时间', type: '类型', currency: '币种',
      amount: '变动金额', afterRemain: '变动后剩余', detail: '关联会员 / 操作详情',
    },
    total: '共 {count} 条',
  },
  chip: {
    label: '我的额度',
    unallocated: '未分配',
    tooltip: '点击查看我的调账额度明细',
  },
  opuser: {
    agent: {
      column: {
        title: '代理调账额度',
        subtitle: '市场推广 · 给代理分配',
        tagNew: '新',
      },
      btn: { manage: '额度管理', manageNew: '新' },
      manage: {
        title: '代理调账额度管理',
        banner: '此为操作员的「代理分配池」，与左侧用户调账额度互不相通。',
      },
      adjust: {
        title: '调整代理调账额度',
        success: '操作成功',
        fail: '操作失败',
      },
    },
  },
  agent: {
    btn: { manage: '额度管理' },
    column: { title: '当前额度', subtitle: '已用 / 可用' },
    whitelist: {
      bannerTitle: '白名单授权说明：',
      bannerDesc:
        '该代理仅可对白名单中的会员执行调账。默认空白名单：该代理不可调任何会员。后台账号操作员不受此权限限制。',
      addBtn: '+ 添加会员',
      downloadTemplate: '下载模板',
      batchImportBtn: '批量导入',
      totalText: '共 {count} 人',
      search: {
        placeholder: '搜索会员账号',
        btn: '搜索',
      },
      stats: {
        whitelistCount: '白名单已配置：',
        directCount: '该代理名下玩家：',
        coverRate: '覆盖率：',
        unit: '人',
        emptyHint: '默认空白名单：该代理不可调任何会员',
      },
      col: {
        account: '会员账号',
        vipLevel: '会员等级',
        addTime: '添加时间',
        addedBy: '添加人',
        action: '操作',
      },
      add: {
        accountLabel: '会员账号',
        placeholder: '请输入完整的会员账号',
        accountRequired: '请输入会员账号',
        helpText: '会员必须存在且属于本代理',
        success: '添加成功',
        alreadyExists: '该会员已在白名单中',
      },
      failReason: {
        MEMBER_NOT_FOUND: '会员不存在',
        NOT_DIRECT_MEMBER: '该会员不属于本代理',
        QUERY_ERROR: '查询会员失败',
      },
      remove: {
        btn: '移除',
        confirmTitle: '确认移除？',
        confirmContent: '将从白名单移除 {account}，移除后该代理无法再对其调账（已有余额不变）',
        success: '已移除',
      },
      batchImport: {
        title: '批量导入会员',
        helpText: '上传 csv 文件或直接粘贴账号 (每行一个，# 开头会被忽略)',
        uploadBtn: '上传 CSV / TXT',
        placeholder: '直接粘贴会员账号，每行一个',
        submit: '导入',
        empty: '请填写至少一个会员账号',
        done: '导入完成：新增 {added} 条 · 已跳过 {skipped} 条 · 失败 {failed} 条',
        added: '✓ 新增成功',
        skipped: '⚠ 已存在跳过',
        failed: '✗ 失败',
      },
    },
    manage: {
      title: '代理调账限额管理',
      accountLabel: '账号',
      monthlyConsumedLabel: '本月已消耗',
      monthConsumed: '本月已消耗',
      poolTitle: '调账额度（单池）',
      poolHint: '操作说明：L1 单池：调账额度（消耗在玩家手工调账）+ 调账额度（消耗在分给名下 L2）。单池统一，互不打通。',
      typeAllocateIn: '↓ 分配获得',
      typeAllocateOut: '↑ 分配下发',
      tab: {
        quota: '调账额度',
        memberConfig: '可调账会员配置',
      },
      memberConfigComingSoon: '该 Tab 为占位，与额度独立，后续接专门接口。',
    },
  },
  wallet: {
    operatorRow: {
      operator: '操作员：',
      willDeduct: '本次调账将扣减您的「{currency}」调账额度',
      viewDetail: '查看完整明细 →',
    },
    preview: {
      after: '→ 调整后剩余额度：{remain} {currency}',
      insufficient: '→ 不足 {amount} {currency}',
      viewDetail: '查看明细 →',
    },
    banner: {
      title: '本次调账将被拦截',
      desc: '无法提交：调整金额（{amount}）超过当前剩余调账额度（{remain} {currency}）。请联系拥有「后台账号.额度.管理」权限的账号补充后重试。',
    },
  },
};
